import _styled from "@emotion/styled/base";
import { css } from '@emotion/react';
import { getResetByTag, colors, typography, rem } from '../../../styles';
var defaultStyles = function defaultStyles(_ref) {
  var disabled = _ref.disabled;
  return /*#__PURE__*/css("color:", disabled ? colors.coolGray_500 : colors.coolGray_700, ";font-size:", typography.typographyBodySm, ";font-weight:", typography.typographyFontWeightNormal, ";display:block;margin-top:", rem(6), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:defaultStyles;"));
};
var inverseStyles = function inverseStyles(_ref2) {
  var isInverse = _ref2.isInverse;
  if (isInverse) return /*#__PURE__*/css("color:", colors.white, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:inverseStyles;"));
};
var resetStyles = getResetByTag('span');
var StyledSelectablePanelTextHint = /*#__PURE__*/_styled('span', process.env.NODE_ENV === "production" ? {
  target: "ex7ecp90"
} : {
  target: "ex7ecp90",
  label: "StyledSelectablePanelTextHint"
})(resetStyles, defaultStyles, inverseStyles);
export default StyledSelectablePanelTextHint;